import { EmailListValidator } from './emailList';
import { DateRangeValidator } from './dateRange';

export const validatorsModule = angular
	.module('phoenix.validators', [])
	.directive('emaillist', EmailListValidator)
	.directive('daterange', DateRangeValidator);


// WEBPACK FOOTER //
// ./src/phoenix/validators/index.ts